module.exports = __webpack_public_path__ + "img/headerLogo2.274cc0ab.svg";